// extracted by mini-css-extract-plugin
var _1 = "actionCall__Qs6rc";
var _2 = "buttonWrapper__nvRfN";
var _3 = "container__cnmIX";
var _4 = "markText__yTI2i";
var _5 = "subtitle__l9wXH";
var _6 = "title__g3ID_";
var _7 = "titleWrapper__jKg5l";
export { _1 as "actionCall", _2 as "buttonWrapper", _3 as "container", _4 as "markText", _5 as "subtitle", _6 as "title", _7 as "titleWrapper" }
export default { "actionCall": _1, "buttonWrapper": _2, "container": _3, "markText": _4, "subtitle": _5, "title": _6, "titleWrapper": _7 }
